module.exports = __webpack_public_path__ + "img/user.4a53941c.png";